/**
 * shadcn's useFormField: the field's state and the ids that tie its label,
 * control, description and message together. Its own file so form.tsx
 * exports only components.
 *
 * @module use-form-field
 */
import * as React from "react"
import { FieldError, useFormContext } from "react-hook-form"
import { FormFieldContext, FormItemContext, type FormFieldContextValue, type FormItemContextValue } from "./form-context"

/** The current field's name, ids and validation state, inside a FormField and FormItem. */
export const useFormField = (): {
  id: string;
  name: string;
  formItemId: string;
  formDescriptionId: string;
  formMessageId: string;
  error?: FieldError;
  invalid: boolean;
  isDirty: boolean;
  isTouched: boolean;
  isValidating: boolean;
} => {
  const fieldContext = React.useContext<FormFieldContextValue>(FormFieldContext)
  const itemContext = React.useContext<FormItemContextValue>(FormItemContext)
  const { getFieldState, formState } = useFormContext()

  const fieldState = getFieldState(fieldContext.name, formState)

  if (!fieldContext) {
    throw new Error("useFormField should be used within <FormField>")
  }

  const { id } = itemContext

  return {
    id,
    name: fieldContext.name,
    formItemId: `${id}-form-item`,
    formDescriptionId: `${id}-form-item-description`,
    formMessageId: `${id}-form-item-message`,
    ...fieldState,
  }
} 